export const mapCurrencyCodeToCountryCode = (currencyCode) => {
    const countryCode = {
        sek: 'SE',
        usd: 'US',
        jpy: 'JP',
        gbp: 'GB',
        nok: 'NO',
        eur: 'EU',
        dkk: 'DK',
    }[currencyCode.toLowerCase()];
    if (!countryCode)
        throw `CurrencyCode ${currencyCode} has no mapping to country code`;
    return countryCode;
};
